export default __webpack_public_path__ + "static/media/p-drum-machine.6355ccff.jpg";